module.exports = __webpack_public_path__ + "img/operate_pay.34f471cc.png";